import {
    allPeopleLabel,
    allGroupsFilter,
    ownedGroupsLabel,
    joinedGroupsLabel,
    allListsFilterLabel,
    distributionListsLabel,
} from './personaListFilterUtils.locstring.json';
import { allLabel } from 'owa-locstrings/lib/strings/alllabel.locstring.json';
import { directoryLabel } from 'owa-locstrings/lib/strings/directorylabel.locstring.json';
import { showPeopleLabel, showContactListsLabel } from '../strings.locstring.json';
import loc from 'owa-localize';

import { Filter } from '../../appstate';

export function toFilterName(filter: Filter): string {
    switch (filter) {
        case Filter.All:
            return loc(allLabel);
        case Filter.HubPerson:
            return loc(allPeopleLabel);
        case Filter.Contact:
            return loc(showPeopleLabel);
        case Filter.Organization:
            return loc(directoryLabel);
        case Filter.Group:
            return loc(allGroupsFilter);
        case Filter.OwnedGroup:
            return loc(ownedGroupsLabel);
        case Filter.JoinedGroup:
            return loc(joinedGroupsLabel);
        case Filter.List:
            return loc(allListsFilterLabel);
        case Filter.PrivateDistributionList:
            return loc(showContactListsLabel);
        case Filter.PublicDistributionList:
            return loc(distributionListsLabel);

        default:
            throw new Error('Not implemented');
    }
}

export function toLoggingFilterName(filter: Filter): string {
    return Filter[filter];
}
